import { WonTitle } from '@/model';
import {
  GetTeamWonTitleByIdResponse,
  GetTeamWonTitleItemResponse,
  GetTeamWonTitleResponse,
  PostTeamWonTitleResponse,
  PutTeamWonTitleResponse,
} from '@/services/response/won-title';

export class WonTitleConverter {
  static toDomainFromGetItemResponse(response: GetTeamWonTitleItemResponse): WonTitle {
    return {
      uuid: response.uuid,
      competition_uuid: response.competition_uuid,
      competition_name: response.competition_name,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetTeamWonTitleResponse): WonTitle[] {
    return response.data.map(WonTitleConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostTeamWonTitleResponse): WonTitle {
    return {
      uuid: response.uuid,
      competition_uuid: response.competition_uuid,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetTeamWonTitleByIdResponse): WonTitle {
    return {
      uuid: response.uuid,
      competition_uuid: response.competition_uuid,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutTeamWonTitleResponse): WonTitle {
    return {
      uuid: response.uuid,
      competition_uuid: response.competition_uuid,
      year: response.year,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
